/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    feature: { type: 'variant', values: [ true ] },
    inverse: { type: 'variant', values: [ true ] },
    label: { type: 'variant', values: [ true ] },
    large: { type: 'variant', values: [ true ] },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: {
        containerPaddingBottomTop: 16,
        containerPaddingLeftRight: 24,
        labelFontSize: 16,
        labelLineHeight: 1.5,
        textLineHeight: 1.5
      }
    },
    {
      if: { feature: true },
      tokens: {
        containerBorderColor: '#000000',
        labelBorderColor: '#000000',
        textFontSize: 70,
        textLineHeight: 1.2,
        textTimerFontName: 'StagSans',
        textTimerFontWeight: '700'
      }
    },
    {
      if: { large: true },
      tokens: {
        labelFontName: 'StagSans',
        labelFontSize: 16,
        labelFontWeight: '400',
        textFontSize: 70,
        textLineHeight: 1.2,
        textTimerFontName: 'StagSans',
        textTimerFontWeight: '700'
      }
    },
    {
      if: { large: true, viewport: [ 'xs' ] },
      tokens: { textFontSize: 44, textLineHeight: 1.22222222222 }
    },
    {
      if: { feature: true, viewport: [ 'xs' ] },
      tokens: { textFontSize: 44 }
    },
    {
      if: { inverse: true },
      tokens: { containerBorderColor: '#ffffff', labelBorderColor: '#ffffff' }
    }
  ],
  tokens: {
    containerBorderColor: 'rgba(0, 0, 0, 0)',
    containerBorderRadius: 6,
    containerBorderWidth: 2,
    containerGradient: null,
    containerInverseBorder: 2,
    containerInverseBorderColor: '#ffffff',
    containerPaddingBottomTop: 48,
    containerPaddingLeftRight: 64,
    inverseBorderColor: null,
    labelBorderColor: null,
    labelFontName: 'StagSans',
    labelFontSize: 16,
    labelFontWeight: '400',
    labelLineHeight: 1.5,
    textFontSize: 16,
    textLineHeight: 1.5,
    textTimerFontName: 'StagSans',
    textTimerFontWeight: '400'
  }
}
export default theme
